import type {
  TranscriptionInputDeviceConfig,
  TranscriptionInputDeviceStorage,
} from '@/features/transcription-input-device';
import { settingsStore } from '@/stores/settings.store';

const dictationPreferenceStorage: TranscriptionInputDeviceStorage = {
  read: () => settingsStore.preferredDictationInputDevice,
  write: (selection) =>
    settingsStore.setPreferredDictationInputDevice(selection),
};

export const DICTATION_INPUT_DEVICE_CONFIG: TranscriptionInputDeviceConfig = {
  cacheKey: 'dictation',
  storage: dictationPreferenceStorage,
  displayMode: 'saved_preference',
  shouldApplyImmediately: () => false,
};
